import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GameModeService } from '../../../_services/game-mode.service';
import { QuizSession } from '../../../interfaces/question.interface';
import { ClassCreature } from '../../../interfaces/creature.interface';
import { getDailyBonusTopic } from '../../../data/league-config';
import { GlobalService } from 'src/app/_services/global.service';

@Component({
  selector: 'app-quiz-summary',
  templateUrl: './quiz-summary.component.html',
  styleUrls: ['./quiz-summary.component.scss']
})
export class QuizSummaryComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  session: QuizSession | null = null;
  creature: ClassCreature | null = null;
  currLang: any = 'en';

  totalQuestions = 0;
  correctAnswers = 0;
  totalXP = 0;
  accuracy = 0;
  dailyBonusApplied = false;

  constructor(
    private gameModeService: GameModeService,
    private globalService: GlobalService
  ) {}

  ngOnInit(): void {
    this.gameModeService.quizSession$
      .pipe(takeUntil(this.destroy$))
      .subscribe(session => {
        this.session = session;
        if (session) {
          this.totalQuestions = session.answers.length;
          this.correctAnswers = session.answers.filter(a => a.isCorrect).length;
          this.totalXP = session.answers.reduce((sum, a) => sum + a.xpEarned, 0);
          this.accuracy = this.totalQuestions > 0 ? Math.round((this.correctAnswers / this.totalQuestions) * 100) : 0;
          const bonus = getDailyBonusTopic();
          this.dailyBonusApplied = session.subject === bonus.subject;
        }
      });

    this.gameModeService.creature$
      .pipe(takeUntil(this.destroy$))
      .subscribe(c => this.creature = c);

    this.globalService.getLang()
      .pipe(takeUntil(this.destroy$))
      .subscribe(lang => this.currLang = lang);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getPerformanceEmoji(): string {
    if (this.accuracy >= 90) return 'excellent';
    if (this.accuracy >= 70) return 'great';
    if (this.accuracy >= 50) return 'good';
    return 'keep-trying';
  }

  finish(): void {
    this.gameModeService.finishQuiz();
  }

  playAgain(): void {
    this.gameModeService.finishQuiz();
    this.gameModeService.setPhase(
      (this.gameModeService as any)._gamePhase ? 'SUBJECT_PICK' as any : 'SUBJECT_PICK' as any
    );
  }
}
